import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCameraRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.455 4a3 3 0 0 0-2.846 2.051L7.292 7H6.013a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-1.28l-.315-.949A3 3 0 0 0 13.572 4h-3.117Zm-.949 2.684A1 1 0 0 1 10.455 6h3.117a1 1 0 0 1 .948.684l.949-.316-.949.316.545 1.632a1 1 0 0 0 .948.684h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 .949-.684l.544-1.632ZM11.013 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCameraRoundLine);
export default Memo;
